export const Trigger3DSizes = {
    // Keyframe values for animating scale of trigger for default state.  Groups of 3, - x,y,z
    TRIGGER_DEFAULT_SCALE_ANIM_COFACTOR: [1, 1, 1],
    // Keyframe values for animating scale of trigger for hoverEnter state.  Groups of 3, - x,y,z
    TRIGGER_HOVER_TARGET_SCALE_ANIM_COFACTOR: [2, 2, 2],
    // Keyframe values for animating scale of trigger for panning state.  Groups of 3, - x,y,z
    TRIGGER_PANNING_TARGET_SCALE_ANIM_COFACTOR: [1.5, 1.5, 1.5],

    // Offset for blur effect in physical space.  Needed to avoid z-fighting
    BLUR_OFFSET: {
        x: 0,
        y: 0.0075,
        z: 0,
    },

    // Offset and scale for visited checkmark
    VISITED_CHECK_OFFSET: {
        x: 0.3,
        y: 0.3,
        z: 0,
    },
    VISITED_CHECK_SCALE: {
        x: 0.15,
        y: 0.15,
        z: 0.15,
    },

    // Sizing and scale values for root object
    TRIGGER_RADIUS: 0.2,
    TRIGGER_DEFAULT_SCALE: {
        x: 1,
        y: 1,
        z: 1,
    },
}

export const Trigger3DSpeeds = {
    // Autoplay rotation speed
    TRIGGER_HOVER_VIDEO_ROTATION_SPEED: 0.0002,
    // Duration for hoverEnter scale anim
    TRIGGER_SCALE_HOVER_DURATION: 0.25,
    // Duration for panning scale anim
    TRIGGER_SCALE_PANNING_DURATION: 0.25,
}

export const Trigger3DRotations = {
    // Offset for centering video texture
    TRIGGER_PANNING_VIDEO_TEXTURE_OFFSET: {
        x: 0.375,
        y: 0.25,
    },
    // Value for scaling video texture
    TRIGGER_PANNING_VIDEO_TILING_REPEAT: {
        x: 0.25,
        y: 0.5,
    },
}
